/**
 * Search snippets embed literal `<mark>…</mark>` tags around matched tokens (Typesense's own; Algolia's
 * through `highlightPreTag` in the transport).
 * We NEVER feed those to `dangerouslySetInnerHTML` — a snippet is user/record
 * data and could smuggle markup. Instead split the string into ordered segments
 * the row renders as React text nodes (React escapes them), flagging the pieces
 * that sat inside a `<mark>` so the row can wrap only those.
 *
 *   "pick <mark>Fuji</mark> now"  ─▶  [ {t:"pick ",m:false},
 *                                       {t:"Fuji", m:true},
 *                                       {t:" now", m:false} ]
 */
export interface SnippetSegment {
  text: string;
  marked: boolean;
}

const MARK_SPLIT = /<mark>|<\/mark>/;

export function splitHighlightSnippet(snippet: string): SnippetSegment[] {
  const pieces = snippet.split(MARK_SPLIT);
  const segments: SnippetSegment[] = [];
  // The delimiters alternate open/close, so a running toggle tracks whether the
  // NEXT piece sat inside a <mark>. Starts outside (first piece is pre-mark text).
  let inside = false;
  for (const piece of pieces) {
    if (piece.length > 0) segments.push({ text: piece, marked: inside });
    inside = !inside;
  }
  return segments;
}
